import React from 'react';
import loadable from '@loadable/component';
import SignupAndLoginMicroFrontend from '../MicroFrontend/SignupAndLogin';
import LoginAndRegisterPopUp from './LoginAndRegisterPopUp';
import AccountFlyout from './AccountFlyout';
import ProductFiltersFlyout from './ProductFiltersFlyout';
import { ShopToClub, ShopToClubDoubleOptIn } from './ShopToClub';
import { OverlayId } from './types';
import { useOverlayStateChecker } from './useOverlayStateChecker';
import useOverlayStateFromUrl from './useOverlay';
import LooksFiltersFlyout from './LooksFilterFlyout';
import PDPZoomFlyout from 'Client/components/ProductDetailPage/PDPZoomFlyout';
import useFeatureToggle from 'Client/hooks/useFeatureToggle';
import { AppBannerValues } from 'Common/appshell_types';
import { PageType } from 'Client/hooks/UrlManager/types';
import { useCurrentPageType } from 'Client/hooks/UrlManager/pageTypeHooks';
import useBrazeReady from 'Client/hooks/Braze/useBrazeReady';

const NewAccountFlyout = loadable(() => import('./NewAccountFlyout/index'), { ssr: false });
const ProductRatingsOverlay = loadable(() => import('./ProductRatingsOverlay'));
const TwoManHandlingOverlay = loadable(() => import('./TwoManHandlingOverlay'));
const FabricSampleOverlay = loadable(() => import('./FabricSample'));
const EnergyEfficiencyOverlay = loadable(() => import('./EnergyEfficiency'));
const AppPushPopUpBig = loadable(() => import('./AppPush/Big'));
const AppPushPopUpSmall = loadable(() => import('./AppPush/Small'));
const SizeSelectorOverlay = loadable(() => import('./SizeSelectorOverlay'));
const PDPThreeDImageOverlay = loadable(() => import('Client/components/ProductDetailPage/ThreeDImage'));

// eslint-disable-next-line complexity
const Overlays = () => {
    const { p100AppBanner, p100PdpThreeDImage, p100SignupOverlayMicroFrontend } = useFeatureToggle();
    const { pageType } = useCurrentPageType();
    useOverlayStateFromUrl();
    useBrazeReady();
    const overlayStateChecker = useOverlayStateChecker();
    const isNewAccountActive = overlayStateChecker(OverlayId.ACCOUNT_MENU);
    const isRatingOverlayActive = overlayStateChecker(OverlayId.RATE_YOUR_PRODUCT);
    const isTwoManHandlingOverlayActive = overlayStateChecker(OverlayId.TWO_MAN_HANDLING);
    const isFabricSampleOverlayActive = overlayStateChecker(OverlayId.FABRIC_SAMPLE_OVERLAY);
    const isEnergyEfficiencyOverlayActive = overlayStateChecker(OverlayId.ENERGY_EFFICIENCY);
    const isPDPThreeDImageOverlayActive = overlayStateChecker(OverlayId.PDP_THREE_D_IMAGE);
    const isPDPZoomActive = overlayStateChecker(OverlayId.PDP_IMAGE_ZOOM);
    const isPDP = pageType === PageType.PDP;

    return (
        <div>
            <LoginAndRegisterPopUp />
            <AccountFlyout />
            {isNewAccountActive && <NewAccountFlyout />}
            <ProductFiltersFlyout />
            <LooksFiltersFlyout />
            {p100SignupOverlayMicroFrontend ? (
                <SignupAndLoginMicroFrontend />
            ) : (
                <>
                    <ShopToClub overlayId={OverlayId.SHOP_TO_CLUB_REGISTRATION_SINGLE_STEP_OVERLAY} />
                    <ShopToClub overlayId={OverlayId.SHOP_TO_CLUB_REGISTRATION_MULTI_STEP_OVERLAY} />
                </>
            )}
            <ShopToClubDoubleOptIn />
            {isPDPZoomActive && <PDPZoomFlyout />}
            {isPDP && <SizeSelectorOverlay />}
            {p100PdpThreeDImage && isPDPThreeDImageOverlayActive && <PDPThreeDImageOverlay />}
            {isRatingOverlayActive && <ProductRatingsOverlay />}
            {isTwoManHandlingOverlayActive && <TwoManHandlingOverlay />}
            {isFabricSampleOverlayActive && <FabricSampleOverlay />}
            {isEnergyEfficiencyOverlayActive && <EnergyEfficiencyOverlay />}
            {p100AppBanner === AppBannerValues.small && <AppPushPopUpSmall />}
            {p100AppBanner === AppBannerValues.big && <AppPushPopUpBig />}
        </div>
    );
};

export default Overlays;
